/**
 * Mirrors custom-size measurements into the cart note as key: value pairs.
 *
 * The measurements already travel as line item properties, which is where
 * Shopify shows them on the order. The note is a second, human-readable copy in
 * one place — the thing you read before cutting, without opening each line.
 *
 * The note is REGENERATED from cart state on every change, never appended to.
 * Appending looks simpler and is wrong: add the same garment twice, or remove
 * one, and an appended note keeps measurements for items nobody ordered. The
 * cart is the source of truth; the note is derived from it.
 */
(function () {
  if (window.__khimuliCartNote) return;
  window.__khimuliCartNote = true;

  const MARKER = 'Custom size';
  const HEADING = 'Custom measurements';
  // Guards against our own /cart/update.js re-entering the interceptor.
  let writing = false;

  const isCartWrite = (url) =>
    typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);

  function buildNote(cart) {
    const blocks = cart.items
      .filter((item) => item.properties && item.properties[MARKER])
      .map((item) => {
        const name =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `${item.product_title} — ${item.variant_title}`
            : item.product_title;

        const pairs = Object.entries(item.properties)
          // The marker itself is plumbing, and Shopify hides _-prefixed keys.
          .filter(([key, value]) => key !== MARKER && !key.startsWith('_') && String(value).trim())
          .map(([key, value]) => `${key}: ${value}`);

        return pairs.length ? [name, ...pairs].join('\n') : null;
      })
      .filter(Boolean);

    return blocks.length ? `${HEADING}\n\n${blocks.join('\n\n')}` : '';
  }

  async function sync() {
    if (writing) return;
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const next = buildNote(cart);
      const current = cart.note || '';

      // A note the customer typed themselves is theirs. Only take ownership of
      // one we generated, so we never overwrite a delivery instruction.
      const ours = current === '' || current.startsWith(HEADING);
      if (!ours || next === current) return;

      writing = true;
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: next }),
      });
    } catch (error) {
      // A failed note must never block the customer from checking out — the
      // measurements are already safe on the line item either way.
      console.warn('[khimuli] cart note sync failed', error);
    } finally {
      writing = false;
    }
  }

  // Wrapping fetch rather than guessing at theme events: every cart mutation in
  // Horizon goes through these endpoints, so this fires exactly once per change
  // and needs no timers.
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const result = nativeFetch.apply(this, arguments);
    if (isCartWrite(url) && !writing) {
      result.then((response) => {
        if (response && response.ok) sync();
      }).catch(() => {});
    }
    return result;
  };

  // Covers a cart form that posts without JavaScript.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form && /\/cart/.test(form.getAttribute('action') || '')) setTimeout(sync, 600);
  });
})();
